/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pt-select-pro.vue?vue&type=template&id=921ce620&"
import script from "./pt-select-pro.vue?vue&type=script&lang=ts&"
export * from "./pt-select-pro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports